<ng-scrollbar [autoHeightDisabled]="false">
  <div class="cards-container">
    @for (form of formPaymentFees; track form) {
      <mat-card appearance="outlined" class="mat-elevation-z0 open-card">
        <mat-card-content class="less-padding">
          <a
            matRipple
            fxFlex="grow"
            [routerLink]="['/admin/forms/', form.formId]"
          >
            <div fxLayout="row">
              <mat-card-header fxFlex="grow">
                <mat-card-title>
                  {{ form.title }}
                </mat-card-title>
              </mat-card-header>
              <div
                [fxFlex]="form?.deadline ? '40' : '10'"
                [fxLayout]="form?.deadline ? 'column' : 'row'"
                [fxLayoutAlign]="form?.deadline ? 'center end' : 'end center'"
              >
                @if (!form?.hasExpired) {
                  <span class="open-status">
                    <svg width="15" height="10">
                      <circle
                        class="status-dot active"
                        cx="5"
                        cy="5"
                        r="4"
                        stroke-width="0"
                      />
                    </svg>
                    Open</span
                  >
                }
                @if (form?.hasExpired) {
                  <span class="closed-status"
                    ><svg width="15" height="10">
                      <circle
                        class="status-dot archived"
                        cx="5"
                        cy="5"
                        r="4"
                        stroke-width="0"
                      />
                    </svg>
                    Closed</span
                  >
                }
                @if (form?.deadline && form?.hasExpired) {
                  <span class="closed-date">on {{ form.deadline | date }}</span>
                }
                @if (form?.deadline && !form?.hasExpired) {
                  <span class="expiration-date"
                    >closes {{ form.deadline | date }}</span
                  >
                }
              </div>
            </div>
          </a>
        </mat-card-content>
      </mat-card>
    }
  </div>
</ng-scrollbar>
